export const validationQuestionForm = (data, changeErrorsForm) => {
    if (!data.name && !data.email && !data.orderName && !data.question) {
        changeErrorsForm({
            name: 'Name is required',
            email: 'Email is required',
            orderName: 'Order Name is required',
            question: 'Question is required',
        })
        return false
    }

    if (!data.name.length) {
        changeErrorsForm({
            name: 'Name is required',
            email: false,
            orderName: false,
            question: false,
        })
        return false
    }
    if (!data.email.length) {
        changeErrorsForm({
            name: false,
            email: 'Email is required',
            orderName: false,
            question: false,
        })
        return false
    }
    if (!data.orderName.length) {
        changeErrorsForm({
            name: false,
            email: false,
            orderName: 'Order Name is required',
            question: false,
        })
        return false
    }
    if (!data.question.length) {
        changeErrorsForm({
            name: false,
            email: false,
            orderName: false,
            question: 'Question is required',
        })
        return false
    }
    return true
}
